import { persistReducer } from "redux-persist";
import { persistStorage } from "@lib/storage";
import {
  SET_HEADER_TITLE,
  RESET_CONFIG_STATE,
  GET_APP_SETTINGS,
  SET_APP_SETTINGS,
  GET_APP_BOOT_PARAMS,
  STATE_STATUS,
  SYNC_USER_ACTIONS,
  GET_APP_BOOT_PARAMS2,
  HANDLE_LEADER_CARD_OPEN,
  HANDLE_LEADER_CARD_COUNT,
  SET_SALES_DATA,
  INVOKE_APP_SETUP,
  CLEAR_APP_SETUP,
  SET_CMOCX_DATA,
  UPDATE_APP_VISIBILITY_SYNC_TIMESTAMP,
  UPDATE_STAR_CP_ACTIVE_ROUTE,
} from "./actionTypes";

export const actions = {
  invokeAppSetup() {
    return {
      type: INVOKE_APP_SETUP,
    };
  },
  syncUser(payload) {
    return {
      type: SYNC_USER_ACTIONS.FETCH_SYNC_USER,
      payload,
    };
  },
  successSyncUser(payload) {
    return {
      type: SYNC_USER_ACTIONS.FETCHED_SYNC_USER,
      payload,
    };
  },
  failureSyncUser(error) {
    return {
      type: SYNC_USER_ACTIONS.FAILED_FETCH_SYNC_USER,
      payload: {
        error,
      },
    };
  },
  setHeaderTitle: (payload) => ({
    type: SET_HEADER_TITLE,
    payload,
  }),
  getAppSettings: () => ({
    type: GET_APP_SETTINGS,
  }),
  getAppBootParams: () => ({
    type: GET_APP_BOOT_PARAMS,
  }),
  getAppBootParams2: () => ({
    type: GET_APP_BOOT_PARAMS2,
  }),
  handleLeaderCardOpen: (bool) => ({
    type: HANDLE_LEADER_CARD_OPEN,
    payload: bool,
  }),
  handleLeaderCardCount: (count) => ({
    type: HANDLE_LEADER_CARD_COUNT,
    payload: count,
  }),
  setSalesData: (data) => ({
    type: SET_SALES_DATA,
    payload: data,
  }),
  clearAppSetup: (payload) => ({
    type: CLEAR_APP_SETUP,
    payload,
  }),
  handleCmoCxData: (payload) => ({
    type: SET_CMOCX_DATA,
    payload,
  }),
  updateAppVisibilitySyncTimestamp: (payload) => ({
    type: UPDATE_APP_VISIBILITY_SYNC_TIMESTAMP,
    payload,
  }),
  updateStarCpActiveRoute: (payload) => ({
    type: UPDATE_STAR_CP_ACTIVE_ROUTE,
    payload,
  }),
};

const appsettings = {
  headerTitle: null,
  HOMESCREEN_BACKGROUND_IMAGE: null,
  SHOW_SKIP_BUTTON_ON_ADDRESS: false,
  SHOW_ADDRESS_FORM_DURING_SIGNUP: false,
  NUM_TIMES_SHOW_OB_VIDEO: 0,
  WA_NUMBER_TO_SAVE_PHONE: "9833692503",
  WA_NUMBER_TO_SAVE_NAME: "CityMall Deals",
  NUM_TIMES_WA_NUMBER_PROMPT_VISIBLE: 3,
  OB_VIDEO_URL: "",
  cmsPoweredEntities: {},
  unavailableMarkingSheet: {
    spreadsheetId: "",
    pizzlyAuthId: "",
  },
  MULTILANG_DISABLED: [],
  ENABLE_WALL_SESSION_TRACKING: true,
};

const initialState = {
  status: STATE_STATUS.UNFETCHED,
  error: null,
  ratingCheck: {},
  version: {},
  homePage: {},
  checkClOrderRating: null,
  oosSku: [],
  banners: {},
  appSettings: appsettings,
  onboardingSupportNumber: [],
  currentMonthStats: {},
  fullCategoryList: [],
  ReplaceReasons: [],
  ReturnReasons: [],
  leaderCardOpen: false,
  leaderCardCount: 0,
  leaderSalesdata: {},
  invokeStatus: STATE_STATUS.UNFETCHED,
  enableWallPolls: false,
  deliveriesInfo: {},
  cmoCx: {
    summary: {},
    customersList: [],
  },
  loggedInDevices: [],
  appVisibilityConfig: {
    syncedTimestamp: null,
  },
  isNewShopPerformanceEnabled: false,
  delivery_communication_enabled: false,
  isStarCp: false,
  isStarCpHasActiveDbs: false,
  isStarCpHasActiveRoutesV2: false,
  isVacationEnabled: false,
  isSortingEnabled: false,
  partialDeliveryEnabled: false,
  multiOrderDelivery: false,
  disable_add_db_btn: false,
  pollingEnable: false,
  pollingInterval: 30,
  features: {},
};

function configReducer(state = initialState, action) {
  switch (action.type) {
    case SYNC_USER_ACTIONS.FETCH_SYNC_USER: {
      return {
        ...state,
        status: STATE_STATUS.FETCHING,
      };
    }

    case SYNC_USER_ACTIONS.FETCHED_SYNC_USER: {
      const { payload = {} } = action;
      let categoriesCopy = [];

      categoriesCopy = payload.categories.map((category) => {
        let cat_slug = "";
        let sub_categories = [];
        if (category.sub_categories.length) {
          cat_slug = category.sub_categories
            .map((x) => x.name_hi)
            .filter((x) => x)
            .join(", ");
          sub_categories = category.sub_categories.map((cat) => {
            const ptype = cat.producttype
              .map((x) => x.producttype_name_hi)
              .filter((x) => x)
              .join(", ");
            return {
              ...cat,
              sub_cat_slug: ptype,
            };
          });
        }
        return {
          ...category,
          sharingLink: payload.sharingLink,
          cat_slug,
          sub_categories,
        };
      });

      return {
        ...state,
        status: STATE_STATUS.FETCHED,
        ratingCheck: action.payload.ratingCheck,
        version: action.payload.version,
        homePage: action.payload.homePage,
        checkClOrderRating: action.payload.checkClOrderRating,
        oosSku: action.payload.oosSku,
        banners: action.payload.banners,
        appSettings: action.payload.appSettings,
        onboardingSupportNumber: action.payload.onboardingSupportNumber,
        tlOffers: action.payload.tlOffers,
        homeOffers: action.payload.homeOffers,
        currentMonthStats: action.payload.currentMonthStats,
        fullCategoryList: categoriesCopy,
        ReplaceReasons: action.payload.ReplaceReasons,
        ReturnReasons: action.payload.ReturnReasons,
        enableWallPolls: action.payload.enableWallPolls ?? true,
        isNewShopPerformanceEnabled: action.payload.isNewShopPerformanceEnabled,
        delivery_communication_enabled:
          action.payload.delivery_communication_enabled,
        isStarCp: action.payload.isStarCp,
        isStarCpHasActiveDbs: action.payload.isStarCpHasActiveDbs,
        isStarCpHasActiveRoutesV2: action.payload.isStarCpHasActiveRoutesV2,
        isVacationEnabled: action.payload.isVacationEnabled,
        isSortingEnabled: action.payload.isSortingEnabled,
        isWalletEnabled: action.payload.isWalletEnabled,
        partialDeliveryEnabled: action.payload.partialDeliveryEnabled,
        multiOrderDelivery: action.payload.multiOrderDelivery,
        disable_add_db_btn: action.payload.disable_add_db_btn,
        pollingEnable: action.payload.pollingEnable,
        pollingInterval: action.payload.pollingInterval,
        features: action.payload.features,
      };
    }

    case SYNC_USER_ACTIONS.FAILED_FETCH_SYNC_USER: {
      return {
        ...state,
        status: STATE_STATUS.FETCH_FAILED,
      };
    }

    case SET_HEADER_TITLE:
      return {
        ...state,
        appSettings: {
          ...state.appSettings,
          headerTitle: action.payload,
        },
      };

    case SET_APP_SETTINGS: {
      const { payload } = action;

      return {
        ...state,
        appSettings: {
          ...state.appSettings,
          ...payload,
        },
      };
    }

    case RESET_CONFIG_STATE: {
      return initialState;
    }

    case HANDLE_LEADER_CARD_OPEN: {
      return {
        ...state,
        leaderCardOpen: action.payload,
      };
    }

    case HANDLE_LEADER_CARD_COUNT: {
      return {
        ...state,
        leaderCardCount: action.payload,
      };
    }

    case SET_SALES_DATA: {
      return {
        ...state,
        leaderSalesdata: action.payload,
      };
    }
    case INVOKE_APP_SETUP: {
      return {
        ...state,
        invokeStatus: STATE_STATUS.FETCHING,
      };
    }
    case "INVOKE_COMPLETE": {
      return {
        ...state,
        invokeStatus: STATE_STATUS.FETCHED,
      };
    }

    case SET_CMOCX_DATA: {
      return {
        ...state,
        cmoCx: {
          summary: { ...state.cmoCx.summary, ...action.payload.summary },
          customersList: {
            ...state.cmoCx.customersList,
            ...action.payload.customersList,
          },
        },
      };
    }

    case UPDATE_APP_VISIBILITY_SYNC_TIMESTAMP: {
      const { payload } = action;
      return {
        ...state,
        appVisibilityConfig: {
          ...state.appVisibilityConfig,
          syncedTimestamp: payload,
        },
      };
    }
    case UPDATE_STAR_CP_ACTIVE_ROUTE: {
      return {
        ...state,
        isStarCpHasActiveRoutesV2: action.payload,
      };
    }
    default:
      return state;
  }
}
const persistConfig = {
  key: "configReducer",
  storage: persistStorage,
  whitelist: ["appVisibilityConfig"],
};
const reducer = persistReducer(persistConfig, configReducer);

reducer.initialState = initialState;

export default reducer;
